import {
  GET_BASIC_PROFILE_REQUEST,
  GET_BASIC_PROFILE_SUCCESS,
  GET_BASIC_PROFILE_FAIL,
} from "../constants/actionTypes";
import { API_URL } from "../config";

const initialState = {
  isLoadingBasicProfile: false,
  errorBasicProfile: null,
};

const basicProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BASIC_PROFILE_REQUEST:
      return {
        ...state,
        errorBasicProfile: null,
        isLoadingBasicProfile: true,
      };
    case GET_BASIC_PROFILE_SUCCESS:
      return {
        ...state,
        userDetailInformation: action.payload,
        isLoadingBasicProfile: false,
        avatarData: `${API_URL}/org-api/resource/image?file=${action.payload.avatar}`,
        frontCardData: `${API_URL}/org-api/resource/image/${action.payload.frontOfCard}`,
        backCardData: `${API_URL}/org-api/resource/image/${action.payload.backOfCard}`,
      };
    case GET_BASIC_PROFILE_FAIL:
      return {
        ...state,
        isLoadingBasicProfile: false,
        errorBasicProfile: {
          status: 500,
          error: "Get basic profile error!",
        },
      };
    default:
      return state;
  }
};
export default basicProfileReducer;
